import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { invalidateAiListeningPromptData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'
import {
  CreatePromptPayload,
  PromptListItem,
} from 'src/services/aiListeningApi/brandProfile.types'

interface CreateVariables {
  payload: CreatePromptPayload
  profileId: string
}

interface UseCreateAiListeningPromptMutationParams {
  onError?: (error: AxiosError<AiListeningErrorEnvelope>) => void
  onSuccess?: (prompt: PromptListItem) => void
}

// No toast: the Add Prompt modal answers with its own success / failure modal.
export const useCreateAiListeningPromptMutation = ({
  onError,
  onSuccess,
}: UseCreateAiListeningPromptMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ payload, profileId }: CreateVariables) =>
      AiListeningBrandProfileApiService.createPrompt(profileId, payload),
    onError,
    onSuccess: (prompt) => {
      invalidateAiListeningPromptData(queryClient)
      onSuccess?.(prompt)
    },
  })
}
